import { SEQ_CONSULT_DATA, MATCH_CONSULT_DATA } from '@/constants/seq-consult';
import { SeqConsultRequest } from '@remodeling/remodeling-manager';

export interface SeqForm extends SeqConsultRequest {}

export const CONSULT_TYPES = {
  SEQ: 'SEQ',
  MATCH: 'MATCH',
} as const;
export type ConsultType = keyof typeof CONSULT_TYPES;
export interface ConsultStepData {
  gtmKey: string;
  title: string | null;
  autoNext: boolean;
  data: Array<{
    name: string;
    value: string | number;
  }>;
}
export type SeqConsultStep = keyof typeof SEQ_CONSULT_DATA;
export type MatchConsultStep = keyof typeof MATCH_CONSULT_DATA;
export type Step = SeqConsultStep | MatchConsultStep | 'personal';

export const SEQ_CONSULT_KAKAO_TEMPLATE_CODE = 'AT_20240829154432';
